import { createSlice, current } from '@reduxjs/toolkit';
import { createSkillSchedule } from './skillSchedule-actions';


const skillScheduleSlice = createSlice({
    name: 'skillSchedules',
    initialState: {
      skillSchedules: [],
      workingSkillSchedule: {},
      currentSkillSchedule: {},
      dataValid: false,
      dataLoaded: false
    },
    reducers: {
        setSkillSchedules(state, action) {
            state.skillSchedules = [];
            //state.workingSkillSchedule = {};

            if (!action) return;
            if (!action.payload) return;
            if (!action.payload.skillSchedules) return;

            state.skillSchedules = action.payload.skillSchedules;
            state.dataValid = !!action.payload.dataValid;
            state.dataLoaded = true;
        },
        setSkillSchedule(state, action) {
            if (!action) return;
            if (!action.payload) return;
            if (!action.payload.skillSchedule) {
                state.workingSkillSchedule = {};
                state.currentSkillSchedule = {};
                state.dataValid = !!action.payload.dataValid;
                return;
            }

            state.currentSkillSchedule = action.payload.skillSchedule;
            if (action.payload.isSave) {
                state.workingSkillSchedule = clone(action.payload.skillSchedule);

                const currentSkillSchedules = state.skillSchedules;

                let newSkillSchedules = [...currentSkillSchedules];
                newSkillSchedules = newSkillSchedules.filter(skillSchedule => !!skillSchedule && skillSchedule.name !== action.payload.skillSchedule.name);
                newSkillSchedules.push(action.payload.skillSchedule);
                
                state.skillSchedules = newSkillSchedules;
            } 
            state.dataValid = !!action.payload.dataValid;
        },
        createSkillSchedule(state, action) {
            if (!action) return;
            if (!action.payload) return;
            if (!action.payload.skillSchedule) return;

            const currentSkillSchedules = state.skillSchedules;

            let newSkillSchedules = [...currentSkillSchedules];
            newSkillSchedules.push(action.payload.skillSchedule);
            
            state.skillSchedules = newSkillSchedules;
            state.dataValid = !!action.payload.dataValid;
        },
        deleteSkillSchedule(state, action) {
            if (!action) return;
            if (!action.payload) return;
            if (!action.payload.skillSchedule) return;

            const currentSkillSchedules = state.skillSchedules;

            let newSkillSchedules = [...currentSkillSchedules];
            newSkillSchedules = newSkillSchedules.filter(skillSchedule => !!skillSchedule && skillSchedule.name !== action.payload.skillSchedule.name);
            
            state.skillSchedules = newSkillSchedules;

            const workingSkillSchedule = state.workingSkillSchedule;
            
            if (workingSkillSchedule && workingSkillSchedule.name === action.payload.skillSchedule.name) {
                state.workingSkillSchedule = {};
            }

            const currentSkillSchedule = state.currentSkillSchedule;

            if (currentSkillSchedule && currentSkillSchedule.name === action.payload.skillSchedule.name) {
                state.currentSkillSchedule = {};
            }
            state.dataValid = !!action.payload.dataValid;
        },
        invalidateData(state, action) {
            state.dataValid = false;
        },
        setWorkingSkillSchedule(state, action) {
            if (!action) return;
            if (!action.payload) return;
            if (!action.payload.skillSchedule) {
                state.workingSkillSchedule = {};
                state.currentSkillSchedule = {};
                return;
            }

            if (!compareSkillSchedules(current(state.workingSkillSchedule), action.payload.skillSchedule)) {
                state.currentSkillSchedule = action.payload.skillSchedule;
            }

            state.workingSkillSchedule = clone(action.payload.skillSchedule);
            //state.dataValid = !!action.payload.dataValid;
        }
    }
});

const clone = (o) => {
    if (!o) return null;
    return JSON.parse(JSON.stringify(o));
}

const compareSkillSchedules = (a, b) => {
    if (!a) return !b
    if (!b) return false;
    if (!a.scheduleName) return !b.scheduleName;
    if (!b.scheduleName) return false;
    return a.scheduleName === b.scheduleName;
}

export const skillScheduleActions = skillScheduleSlice.actions;

export default skillScheduleSlice;